function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import GridMouseHandler from "../GridMouseHandler.js";
import GridRange from "../GridRange.js";
import GridUtils from "../GridUtils.js";
var DEFAULT_INTERVAL_MS = 100;
class GridSelectionMouseHandler extends GridMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "startPoint", void 0);
    _defineProperty(this, "hasExtendedFloating", false);
    // Timer used when holding a drag past the end of the grid
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "lastTriggerTime", void 0);
  }
  /**
   * Returns the latest grid selection based on the current grid selection and where the user clicked
   * This code is dependent on the behavior of onContextMenu
   * @param originalSelection The selection from the current grid state which may be stale
   * @param columnIndex The column index where the user clicked
   * @param rowIndex The row index where the user clicked
   */
  static getLatestSelection(originalSelection, columnIndex, rowIndex) {
    var clickedInOriginalSelection = GridRange.containsCell(originalSelection, columnIndex, rowIndex);

    // If the user clicked in a valid cell outside of the original selection,
    // the selection will be changed to just that cell.
    return clickedInOriginalSelection || columnIndex == null || rowIndex == null ? originalSelection : [GridRange.makeCell(columnIndex, rowIndex)];
  }
  onDown(gridPoint, grid, event) {
    var x = gridPoint.x,
      y = gridPoint.y,
      column = gridPoint.column,
      row = gridPoint.row;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var gridX = metrics.gridX,
      gridY = metrics.gridY,
      maxX = metrics.maxX,
      maxY = metrics.maxY;
    var gridMouseX = x - gridX;
    var gridMouseY = y - gridY;
    if (gridMouseX < 0 || gridMouseY < 0 || column == null && gridMouseX > maxX || row == null && gridMouseY > maxY) {
      return false;
    }
    var isModifierKey = GridUtils.isModifierKeyDown(event);
    var isShiftKey = event.shiftKey;
    if (!isModifierKey) {
      if (isShiftKey) {
        grid.trimSelectedRanges();
      } else {
        grid.clearSelectedRanges();
      }
    }
    var theme = grid.getTheme();
    var autoSelectRow = theme.autoSelectRow,
      autoSelectColumn = theme.autoSelectColumn;
    // If they click a column/row header, don't want to select the whole table if auto select column/row is on
    if ((column !== null || !autoSelectColumn) && (row !== null || !autoSelectRow)) {
      grid.focus();
      grid.moveCursorToPosition(column, row, isShiftKey, false, isShiftKey && isModifierKey);
    }
    this.startPoint = gridPoint;
    this.hasExtendedFloating = false;
    return true;
  }
  onDrag(gridPoint, grid) {
    if (this.startPoint === undefined) {
      return false;
    }
    this.stopTimer();
    var _this$startPoint = this.startPoint,
      startRow = _this$startPoint.row,
      startColumn = _this$startPoint.column;
    var x = gridPoint.x,
      y = gridPoint.y;
    var row = gridPoint.row,
      column = gridPoint.column;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var left = metrics.left,
      lastLeft = metrics.lastLeft,
      top = metrics.top,
      lastTop = metrics.lastTop,
      columnWidth = metrics.columnWidth,
      rowHeight = metrics.rowHeight;
    var dragBounds = GridUtils.getScrollDragBounds(metrics, startRow, startColumn);

    // If we're dragging outside of the grid entirely, then we should start scrolling
    var deltaX = 0;
    var deltaY = 0;
    if (left < lastLeft) {
      if (x < dragBounds.x1) {
        deltaX = x - dragBounds.x1;
      } else if (x > dragBounds.x2) {
        deltaX = x - dragBounds.x2;
      }
    }
    if (top < lastTop) {
      if (y < dragBounds.y1) {
        deltaY = y - dragBounds.y1;
      } else if (y > dragBounds.y2) {
        deltaY = y - dragBounds.y2;
      }
    }
    if (deltaX !== 0 || deltaY !== 0) {
      // Have it go faster depending on how far out they've dragged
      this.startTimer(grid, gridPoint, deltaX > 0 ? Math.ceil(deltaX / columnWidth) : Math.floor(deltaX / columnWidth), deltaY > 0 ? Math.ceil(deltaY / rowHeight) : Math.floor(deltaY / rowHeight));
    } else if (row != null && column != null) {
      var floatingTopRowCount = metrics.floatingTopRowCount,
        floatingBottomRowCount = metrics.floatingBottomRowCount,
        floatingLeftColumnCount = metrics.floatingLeftColumnCount,
        floatingRightColumnCount = metrics.floatingRightColumnCount,
        columnCount = metrics.columnCount,
        rowCount = metrics.rowCount,
        bottom = metrics.bottom,
        right = metrics.right,
        topVisible = metrics.topVisible,
        bottomVisible = metrics.bottomVisible,
        leftVisible = metrics.leftVisible,
        rightVisible = metrics.rightVisible;
      // When selection crosses from a floating area to a non floating area, we need to scroll instead of jumping to the floating area
      // So when that happens, just adjust the point to be past the new boundary
      if (!this.hasExtendedFloating) {
        if (startRow !== null && startRow < floatingTopRowCount && row >= floatingTopRowCount) {
          // Extending from floating top into the view
          row = floatingTopRowCount;
          this.hasExtendedFloating = true;
        } else if (startRow !== null && startRow >= rowCount - floatingBottomRowCount && row < rowCount - floatingBottomRowCount) {
          // Extending from floating bottom into the view
          row = rowCount - floatingBottomRowCount - 1;
          this.hasExtendedFloating = true;
        }
        if (startColumn !== null && startColumn < floatingLeftColumnCount && column >= floatingLeftColumnCount) {
          // Extending from floating left into the view
          column = floatingLeftColumnCount;
          this.hasExtendedFloating = true;
        } else if (startColumn !== null && startColumn >= columnCount - floatingRightColumnCount && column < columnCount - floatingRightColumnCount) {
          // Extending from floating right into the view
          column = columnCount - floatingRightColumnCount - 1;
          this.hasExtendedFloating = true;
        }
      }

      // When a selection is dragging from within the main area to over a floating area, scroll.
      if (startRow !== null && !GridUtils.isFloatingRow(startRow, metrics) && GridUtils.isFloatingRow(row, metrics)) {
        // Need to scroll
        if (startRow > row && row < top) {
          row = topVisible - 1;
        } else if (startRow < row && row > bottom) {
          row = bottomVisible + 1;
        }
      }
      if (startColumn !== null && !GridUtils.isFloatingColumn(startColumn, metrics) && GridUtils.isFloatingColumn(column, metrics)) {
        if (startColumn > column && column < left) {
          column = leftVisible - 1;
        } else if (startColumn < column && column > right) {
          column = rightVisible + 1;
        }
      }
      grid.moveCursorToPosition(column, row, true, true);
    }
    return true;
  }
  onUp(gridPoint, grid) {
    if (this.startPoint !== undefined) {
      this.startPoint = undefined;
      this.stopTimer();
      grid.commitSelection();
    }
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  onDoubleClick(gridPoint, grid, event) {
    var column = gridPoint.column,
      row = gridPoint.row;
    if (row == null || column == null) {
      return false;
    }
    grid.clearSelectedRanges();
    grid.moveCursorToPosition(column, row);
    grid.commitSelection();
    return true;
  }
  onContextMenu(gridPoint, grid, event) {
    // check if the selected is already in the selected range
    var selectedRanges = grid.getSelectedRanges();
    var isInRange = GridRange.containsCell(selectedRanges, gridPoint.column, gridPoint.row);

    // only change the selected range if the selected cell is not in the selected range
    if (!isInRange && gridPoint.row !== null && gridPoint.column !== null) {
      this.startPoint = undefined;
      this.stopTimer();
      grid.clearSelectedRanges();
      grid.moveCursorToPosition(gridPoint.column, gridPoint.row);
    }
    return false;
  }
  moveSelection(grid, gridPoint, deltaX, deltaY) {
    var row = gridPoint.row,
      column = gridPoint.column;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var _grid$state = grid.state,
      selectionEndRow = _grid$state.selectionEndRow,
      selectionEndColumn = _grid$state.selectionEndColumn;
    if (selectionEndRow == null || selectionEndColumn == null) {
      throw new Error('selection not set');
    }
    var rowCount = metrics.rowCount,
      columnCount = metrics.columnCount;
    var minX = deltaX < 0 && column != null ? column : 0;
    var maxX = deltaX > 0 && column != null ? column : columnCount - 1;
    var minY = deltaY < 0 && row != null ? row : 0;
    var maxY = deltaY > 0 && row != null ? row : rowCount - 1;
    grid.moveCursorToPosition(Math.min(Math.max(minX, selectionEndColumn + deltaX), maxX), Math.min(Math.max(minY, selectionEndRow + deltaY), maxY), true);
    this.lastTriggerTime = Date.now();
  }
  startTimer(grid, gridPoint, deltaX, deltaY) {
    this.stopTimer();
    var timeout = this.lastTriggerTime != null ? DEFAULT_INTERVAL_MS - Math.min(DEFAULT_INTERVAL_MS, Date.now() - this.lastTriggerTime) : 0;
    this.timer = setTimeout(() => {
      this.moveSelection(grid, gridPoint, deltaX, deltaY);
      this.startTimer(grid, gridPoint, deltaX, deltaY);
    }, timeout);
  }
  stopTimer() {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}
export default GridSelectionMouseHandler;
//# sourceMappingURL=GridSelectionMouseHandler.js.map